import Colyseus from 'colyseus.js';
import { spawnPointContainer } from './spawn-point-container';
import { shotDisplayPool } from './shot-display-pool';
import { leaderboard } from './leaderboard';
import { setShootingEnabled } from './gun';
import { fader } from './fade';
import { isLocalHost, isStaging } from './helpers/utils';
let filter = require('leo-profanity');

export let colyseusObj;

WL.registerComponent('colyseus', {
  useLocalServer: { type: WL.Type.Bool, default: false },
  localPlayer: { type: WL.Type.Object },
  spawnerObj: { type: WL.Type.Object },
  health100: { type: WL.Type.Material },
  health75: { type: WL.Type.Material },
  health50: { type: WL.Type.Material },
  health25: { type: WL.Type.Material },
  deathMaterial: { type: WL.Type.Material },
  healthBody: {type: WL.Type.Object},
  voiceChatObj: { type: WL.Type.Object },
  timerObj: { type: WL.Type.Object },
  notificationObj: { type: WL.Type.Object },
  railsObj: { type: WL.Type.Object },
  startSoundObj: {type: WL.Type.Object},
  shotSoundObj: {type: WL.Type.Object}
}, {
  init: function () {
    // initialize colyseus
    this.health = this.healthBody.getComponent('health-indicator');
    this.syncedShotComponent = this.shotSoundObj.getComponent('synced-shot');
    this.localPlayerKey = null;
    console.log('initializing colyseus component');
    const overlay = document.querySelector('.game-overlay');
    overlay.style.display = 'flex';
    overlay.style.opacity = 1.0;
    this.startSoundHasPlayed = false;
    this.messageBoxOauth = document.querySelector('#message-box-oauth');
    this.messageBoxWeb3 = document.querySelector('#message-box-web3');
    this.messageBoxGuest = document.querySelector('#message-box-guest');

    this.gameStartSound = this.startSoundObj.getComponent('howler-audio-source');
    // setup connection to colyseus client
    colyseusObj = this;
    if (this.useLocalServer) {
      this.client = new Colyseus.Client('ws://localhost:2567');
    } else {
      if (isStaging() || isLocalHost()) {
        this.client = new Colyseus.Client('wss://staging-server.zesty.xyz');
      } else {
        this.client = new Colyseus.Client('wss://production-server.zesty.xyz');
      }
    }

    // setup room
    this.room;
    this.players = new Map();

    // auth events
    this.submitGuest = document.querySelector("#submit-btn-guest");

    this.submitOauth = document.querySelector("#submit-btn-oauth");
    this.joinOauth = document.querySelector("#hidden-join-oauth-btn");

    this.submitWeb3 = document.querySelector("#submit-btn-web3");
    this.joinWeb3 = document.querySelector("#hidden-join-web3-btn");

    // Case 1: Join as guest
    if (this.submitGuest) {
      this.submitGuest.onclick = this.initiateJoinAsGuest.bind(this);
    }
    // Case 2: Join using oauth (not onboarded)
    if (this.submitOauth) {
      this.submitOauth.onclick = this.initiateJoinOauthOnboarding.bind(this);
    }

    // Case 2: Join using oauth (onboarded)
    if (this.joinOauth) {
      this.joinOauth.onclick = this.initiateJoinOauth.bind(this);
    }

    // TODO: join with web3 (not onboarded) and (onboarded)
  },
  getIdByName: function(name){
    let id = '';
    Array.from(this.players.entries()).map(([key, val]) => {
      if(name == val.name){
        id = key;
      }
    });
    return id;
  },
  start: function () {
    this.beep = this.object.getComponent('howler-audio-source');
    this.spawner = this.spawnerObj.getComponent('peer-networked-player-spawner');
    this.voiceChat = this.voiceChatObj.getComponent('voice-chat');
    this.timerText = this.timerObj.getComponent('text');
    this.notification = this.notificationObj.getComponent('notification');
    this.rail = this.railsObj.getComponent('rail-system');
    filter.loadDictionary();
  },
  initiateJoinAsGuest: function() {
    if (this.isJoining) return;
    // Get guest name
    const name = document.querySelector('#display-name-guest')?.value.trim();

    // validate guest name
    if (name === "") {
      this.messageBoxGuest.innerText = "Your username is empty!";
      this.isJoining = false;
      return;
    }

    if (name.length < 3) {
      this.messageBoxGuest.innerText = "Your username is too short!";
      this.isJoining = false;
      return;
    }

    if (name.length > 25) {
      this.messageBoxGuest.innerText = "Your username is too long!";
      this.isJoining = false;
      return;
    }

    if (filter.check(name)) {
      this.messageBoxGuest.innerText = "Your username contains profanities!";
      this.isJoining = false;
      return;
    }

    this.startLoad("[GUEST] " + name, true);
    this.isJoining = true;
  },
  initiateJoinOauthOnboarding: function() {
    if (this.isJoining) return;

    this.isJoining = true;

    // Send onboarding information to server
    const openloginStore = JSON.parse(window.localStorage.getItem('openlogin_store'));
    const gameState = JSON.parse(window.localStorage.getItem('gameState'));
    const name = document.querySelector('#display-name-oauth')?.value.trim();

    fetch(idServer + '/edit-profile', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + openloginStore.idToken,
        'Accept': '*/*'
      },
      body: JSON.stringify({
        appPubKey: gameState.appPubKey,
        ethAddress: gameState.ethAddress,
        displayName: name
      })
    }).then(res => {
      // errors will be found here
      if (!res.ok) {
        res.json().then(jsonBody => {
          console.log(jsonBody);
          this.messageBoxOauth.innerText = jsonBody.error;
          this.isJoining = false;
          return;
        });
      } else {
        fetch(idServer + '/user/' + userId.toString(), {
          method: 'GET'
        }).then(userStats => {
          userStats.json().then(userJson => {
            this.startLoad(`[Lv ${userJson.data.user.deathmatch.level}] ` + name, false);
          });
        });
      }
    }).catch(err => {
      this.isJoining = false;
      console.log(err);
    });
  },
  initiateJoinOauth: function() {
    if (this.isJoining) return;

    this.isJoining = true;
    const name = document.querySelector('#hidden-display-name')?.value.trim();
    fetch(idServer + '/user/' + userId.toString(), {
      method: 'GET'
    }).then(userStats => {
      userStats.json().then(userJson => {
        this.startLoad(`[Lv ${userJson.data.user.deathmatch.level}] ` + name, false);
      });
    });
  },
  startLoad: async function (name, guest) {
    // Join room
    try {
      this.room = await this.client.joinOrCreate("my_room", {
        name: name,
        guest: guest,
        userId: userId
      });

      console.log(this.room.sessionId, "joined", this.room.name, this.room.id);
    } catch (e) {
      console.log("JOIN ERROR", e);
    }

    // Set up state change callbacks
    try {
      this.room.state.players.onAdd = (player, key) => {
        leaderboard.addPlayer(player.name);
        if (key !== this.room.sessionId) {
          this.rail.setEnabled(false);
          const playerRig = this.spawner.getEntity(player.name);
          playerRig.object.name = key;
          this.players.set(key, playerRig);
          console.log(`Player ${key} has been added`);

          player.transform.onChange = (value, idx) => {
            this.players.get(key).updateTransform('body', value, idx);
          }

          player.head.transform.onChange = (value, idx) => {
            this.players.get(key).updateTransform('head', value, idx);
          }

          player.leftHand.transform.onChange = (value, idx) => {
            this.players.get(key).updateTransform('leftHand', value, idx);
          }

          player.rightHand.transform.onChange = (value, idx) => {
            this.players.get(key).updateTransform('rightHand', value, idx);
          }

        } else {
          if(!isLocalHost()){
            this.localPlayer.getComponent('physx').active = false;
            if(spawnPointContainer)
              this.localPlayer.setTranslationWorld(spawnPointContainer.getBestSpawnPoint());
            else
              this.localPlayer.setTranslationWorld([0, 1, 0]);
            setTimeout(() => {
              this.localPlayer.getComponent('physx').active = true;
            }, 50);
          }
        }

        player.gameData.onChange = (changes) => {
          console.log('changes', changes);
          changes.forEach(change => {
            switch(change.field) {
              case "kills":
                leaderboard.updateData(player.name, true, change.value);
                break;
              case "deaths":
                leaderboard.updateData(player.name, false, change.value);
                break;
            }
        });
        }

        let lastPlayerHealth = 100;

        player.listen('health', (cur, prev) => {
          console.log(`${key} current health is now ${cur}, was ${prev}`);
          if (key === this.room.sessionId) {
            // Health event for local player
            const currentPlayer = this.localPlayer;
            const healthIndicator = currentPlayer.getComponent('health-indicator');
            healthIndicator.updateHealth(cur);

            if (cur <= 0) {
              this.room.send('died', { player: key });
              setShootingEnabled(false);
              fader.deathFadeIn();

              // wait 5 seconds, be invincible, then respawn
              setTimeout(() => {
                setShootingEnabled(true);
                currentPlayer.getComponent('physx').active = false;
                if(spawnPointContainer)
                  currentPlayer.setTranslationWorld(spawnPointContainer.getBestSpawnPoint());
                else
                  currentPlayer.setTranslationWorld([0, 1, 0]);
                setTimeout(() => {
                  currentPlayer.getComponent('physx').active = true;
                  currentPlayer.getComponent('physx').kinematic = false;
                }, 50);
                this.room.send('respawned', { player: key });
              }, 5000);
            } else if(cur !== 100){
              fader.hitFadeIn()
            }
          } else {
            // Health event for other player
            const player = this.players.get(key);
            // const healthIndicator = player.object.getComponent('health-indicator');
            // healthIndicator.updateHealth(cur);
            lastPlayerHealth = cur;

            if(cur <= 0) {
              player.object.getComponent('peer-networked-player').applyMaterial(this.deathMaterial);
            } else {
                if(prev > cur) {
                  let playerTempMaterial;
                  if(cur >= 80)
                    playerTempMaterial = this.health100
                  else if(cur >= 60)
                    playerTempMaterial = this.health75
                  else if(cur >= 40)
                    playerTempMaterial = this.health50
                  else
                    playerTempMaterial = this.health25

                  player.object.getComponent('peer-networked-player').applyMaterial(playerTempMaterial);
                  setTimeout(() => {
                    if(lastPlayerHealth === cur)
                      player.object.getComponent('peer-networked-player').resetMaterial();
                  }, 250);

                  } else {
                  player.object.getComponent('peer-networked-player').resetMaterial();
                }
            }
          }
        });

        player.listen('kills', (cur, prev) => {
          if (key === this.room.sessionId) {
            leaderboard.updateData(player.name, true, cur);
          }
        });

        player.listen('deaths', (cur, prev) => {
          if (key === this.room.sessionId) {
            leaderboard.updateData(player.name, false, cur);
          }
        });
      }

      this.room.state.players.onRemove = (player, key) => {
        this.spawner.returnEntity(this.players.get(key).object);
        leaderboard.removePlayer(player.name);
        console.log(`Player ${key} has been removed`);
        if (this.room.state.players.size === 1) {
          this.rail.setEnabled(true);
          this.rail.updateCount(false);
        }
      }

      this.room.state.listen('timeRemaining', (currentValue, previousValue) => {
        let minutes = Math.floor((currentValue / 1000) / 60);
        let seconds = ((currentValue / 1000) % 60).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})

        let message = '';
        if (this.room.state.players.size < 2) {
          text = 'Waiting for more players...';
        } else {
          if (!this.roundStarted){
            this.beep.play();
            this.startSoundHasPlayed = false;
          }
          if (this.roundStarted && !this.startSoundHasPlayed) {
            this.startSoundHasPlayed = true;
            this.gameStartSound.play();
          }
          message = `${this.roundStarted ? '' : 'Next round in\n'}${minutes}:${seconds}`;
        }
        this.timerText.text = message;
      });

      this.room.state.listen('roundStarted', (currentValue, previousValue) => {
        this.roundStarted = currentValue;
      });

      this.room.onMessage('otherShoot', (message) => {
        this.syncedShotComponent.playSpatialShot(message.shotOrigin);
        shotDisplayPool.getEntity().shoot(message.shotOrigin, message.destination, message.distance);
      });

      this.room.onMessage('playerJoin', (message) => {
        this.notification.notification(`${message} has joined!`)
      });

      // this.room.onMessage('playerLeave', (message) => {
      //   this.notification.notification(`${message.name} has left!`)
      // });

      this.room.onMessage('roundEnd', (message) => {
        this.timerText.text = message;
      });

      this.room.onMessage('playerElim', (message) => {
        this.notification.notification("ELIMINATED " + message.name);
      });

      this.room.onMessage('playerGotElim', (message) => {
        this.notification.notification("ELIMINATED BY " + message.name);
      });

      this.room.onLeave((code) => {
        switch (code) {
          case 4000: // Kicked for 2 minutes inactivity
            this.notification.notification('KICKED FOR INACTIVITY', true);
            this.voiceChat.disconnect();
            break;
        }
      })

      this.onJoinSuccessful();
    } catch (e) {
      console.log('Failed setting up callbacks', e);
    }
  },

  onJoinSuccessful: function() {
    this.voiceChat.connect(this.room.sessionId);
    enableVRButton();
  },

  update: function (dt) {
    // Do something on every scene tick or frame.
  }
});
